import { render, staticRenderFns } from "./ReviewChatMessage.htm?vue&type=template&id=4c313fff&scoped=true&"
import script from "./ReviewChatMessage.ts?vue&type=script&lang=js&"
export * from "./ReviewChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./ReviewChatMessage.scss?vue&type=style&index=0&id=4c313fff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c313fff",
  null
  
)

export default component.exports